<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm" :inline="true">
      <el-form-item prop="userId" v-if="showAdmin">
        <el-select v-model="queryParams.userId" filterable placeholder="代理商" @change="searchSubAgent" clearable>
          <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="distributionUserId">
       <el-select v-model="queryParams.distributionUserId" filterable placeholder="下级代理商" @change="search" clearable>
          <el-option v-for="(item,index) in targetAgentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="iccid">
        <el-input
          v-model="queryParams.iccid"
          placeholder="请输入ICCID"
          clearable
          style="width: 240px"
          @keyup.enter.native="search"
        />
      </el-form-item>
      <el-form-item  prop="missionId">
        <el-input
          v-model="queryParams.missionId"
          placeholder="请输入任务ID"
          clearable
          style="width: 240px"
          @keyup.enter.native="search"
        />
      </el-form-item>
      <el-form-item  prop="status">
        <el-select v-model="queryParams.status" 
        placeholder="请选择状态" 
        style="width: 240px" 
        clearable
        @change="search"
        >
          <el-option
            v-for="item in batchStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="chargeTime">
       <el-select v-model="queryParams.chargeTime" filterable placeholder="充值次数" @change="search" clearable>
          <el-option v-for="item in chargeTimes" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-download"  @click="exportDistribution">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="tableData" :default-sort="defaultSort" @sort-change="handleSortChange">
      <el-table-column type="index" label="序号" align="center"></el-table-column>
      <el-table-column  prop="userCompany" label="代理商" align="center" width="220" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>[{{ scope.row.userName }}]{{ scope.row.userCompany }}</span>
          </template>
      </el-table-column>
      <el-table-column  prop="targetCompanyName" label="分配代理商" align="center" width="220" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>[{{ scope.row.distributionUserName }}]{{ scope.row.distributionUserCompany }}</span>
          </template>
      </el-table-column>
      <el-table-column  label="ICCID" align="center" width="220" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="directCardDetail(scope.row.iccid)">{{ scope.row.iccid }}</el-link>
          </template>
      </el-table-column>
      <el-table-column prop="missionId" label="任务ID" align="center"  width="220" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="{row}">
          <el-tag v-if="row.status =='1'"  type="success">成功</el-tag>
          <el-tag v-else type="danger">失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="分配时间" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="firstTime" label="首次充值时间" align="center" sortable="custom" width="160">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.firstTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rechargingTime" align="center" width="160" sortable="custom" >
          <span  slot="header">
            <el-tooltip content="复充时间指第二次以后充值时间，时间实时变更，为最后一次充值时间" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
              复充时间
          </span>
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.rechargingTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rechargeTimes" label="充值次数" align="center" width="160" sortable="custom">
        <template slot-scope="scope">
          <span>{{ scope.row.rechargeTimes }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="失败原因" align="center" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
  </div>
</template>

<script>
import { userAgentList } from "@/api/api.js"; //初始化用户代理商
import {cardDistribution,agentList,agentChildList,exportCardDistribution} from "@/api/api"; //订单
export default {
  name:'distribution',
  data() {
    return {
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 搜索
      queryParams:{
        userId:undefined,
        distributionUserId:undefined,
        iccid:undefined,
        missionId:undefined,
        status:undefined,
        chargeTime:undefined,
      },
      agentList:[],
      targetAgentList:[],
      defaultSort: {prop: 'id', order: 'descending'},
      chargeTimes:[
          {
            value:1,
            label:'充值一次'
          },
          {
            value:2,
            label:'充值二次'
          },
          {
            value:3,
            label:'充值三次'
          },
          {
            value:4,
            label:'充值四次'
          },
          {
            value:5,
            label:'充值大于一次'
          },
          {
            value:6,
            label:'充值大于四次'
          }
      ],
      batchStatus:[
          {
            value:1,
            label:'成功'
          },
          {
            value:0,
            label:'失败'
          }
      ],
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
    };
  },
  computed: {
    showAdmin:{
      get(){
        return this.$store.getters.user.userType =='1'; 
      }
    },
  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'distribution'){
          let missionId  = this.$route.params.missionId
          let chargeTime = this.$route.params.chargeTime
          if(!!missionId){
            this.queryParams.missionId = missionId;
            this.queryParams.chargeTime = chargeTime;
            this.initData();
          }
          
        }
      },
      deep: true
    }
  },
  methods: {
    initUserAgentList(){
      userAgentList().then(res => {
        if (res.data.code == 200) {
          this.agentList = res.data.data;
          this.agentList.forEach((value,index)=>{
            if(!value.company){
                value.company = '';
            }
          })
        }
      });
    },
    /** 排序触发事件 */
    handleSortChange(column) {
      this.queryParams.orderByColumn = column.prop;
      this.queryParams.isAsc = column.order;
      this.initData()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    initData() {
      this.loading = true;
      let params = {
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange)
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      cardDistribution(params).then(res => {
        this.loading = false;
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        }
      });
    },
    //导出卡分配记录
    exportDistribution(){
      let model = {
          ...this.addDateRange(this.queryParams, this.dateRange)
      }
      exportCardDistribution(model).then(res=>{
          if(res.data.code == 200){
              this.$message({
                showClose: true,
                message: '导出成功，前往任务中心下载导出记录',
                type: 'success'
              });
          }else{
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'error'
            });
          }
      })
    },
    // 页面跳转
    handleClick(routerPath){
      this.$router.push(routerPath);
    },
    /** 搜索按钮操作 */
    search() {
      this.page = 1,
      this.initData();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    searchSubAgent(){
      let params ={
        userId:this.queryParams.userId
      }
      agentChildList(params).then(res => {
        if (res.data.code == 200) {
          this.targetAgentList = res.data.data
        }
      })
    },
    //代理商下拉列表
    initAgentList() {
      agentList().then(res => {
        if (res.data.code == 200) {
          this.targetAgentList = res.data.data;
        }
      });
    },
    //跳转卡详情
    directCardDetail(iccid){
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    }
  },
  created() {
    this.initUserAgentList();
    this.initAgentList();
    let missionId  = this.$route.params.missionId
    let chargeTime = this.$route.params.chargeTime
    if(!!missionId){
      this.queryParams.missionId = missionId;
      this.queryParams.chargeTime = chargeTime;
    }
    this.initData();
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
  
</style>>